// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_redotech-redo-web-lib-skeleton-animated-skeleton-block";
export var movingGradient = "_redotech-redo-web-lib-skeleton-moving-gradient";
export var movingGradientBlock = "_redotech-redo-web-lib-skeleton-moving-gradient-block";
export var skeleton = "_redotech-redo-web-lib-skeleton-skeleton";
export var skeletonText = "_redotech-redo-web-lib-skeleton-skeleton-text";